import { APITypesV2 } from "@cur8/api-client";
import { usePatientQuery } from "hooks/queries/usePatientQuery";
import { useSitesQuery } from "hooks/queries/useSitesQuery";
import { useVisitQuery } from "hooks/queries/useVisitQuery";
import { useConfig } from "render/context/ConfigContext";

const ProdTestingPatientGroup = "fcacd5b9-631e-47d4-9aa7-e953fbf9a0ba";
const MoodPatientGroup = "8331ae07-0bca-469c-981f-d468ddf98c71"; // PatientGroup-SE-ARN14

export function useShowNekoLens({
  patientId,
  visitId,
}: {
  patientId: string;
  visitId: string;
}): boolean {
  const { stageType: environment } = useConfig();
  const { data: patientData } = usePatientQuery({ patientId });
  const { data: visit } = useVisitQuery({ patientId, visitId });
  const { data: sites } = useSitesQuery({});

  if (environment === "development") {
    return true;
  }

  const groupIds = patientData?.groupIds ?? [];

  if (groupIds.includes(ProdTestingPatientGroup)) {
    return true;
  }

  if (groupIds.includes(MoodPatientGroup)) {
    const site = sites?.items.find((s) => s.siteId === visit?.siteId);
    return (
      site?.visibility === APITypesV2.SiteVisibility.Internal ||
      site?.visibility === APITypesV2.SiteVisibility.Restricted
    );
  }

  return false;
}
